
var debug = false;
var GlobalFunctions = {
  //db = this.$firebase.firestore();

  name:"teste",
  optionsMoneyBr: {
    locale: "pt-BR",
    prefix: "R$",
    suffix: "",
    length: 11,
    precision: 2,
  },
  formatDecimal(value){
    var d =  Math.round(value*100)/100
     var r  = new Intl.NumberFormat('pt-BR', {
    //  currency: "BRL",
     // style: "currency",
      minimumFractionDigits: 2
    }).format(d || 0)

   return r;
  },
    
}


export default GlobalFunctions;